import { render, staticRenderFns } from "./previewForm.vue?vue&type=template&id=bca3cd80&scoped=true&"
import script from "./previewForm.vue?vue&type=script&lang=js&"
export * from "./previewForm.vue?vue&type=script&lang=js&"
import style0 from "./previewForm.vue?vue&type=style&index=0&id=bca3cd80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca3cd80",
  null
  
)

export default component.exports